<div
  #ndfEntryDefault
  fxFlex
  fxLayout="column"
  fxLayoutAlign="center"
  fxLayoutGap="5px"
  class="order-entry-settings__ndf__body"
>
  <!-- CLIENT -->
  <div fxFlex="1 1 100%" class="order-entry-settings__ndf__row">
    <ic-autocomplete-defaults
      #inputClient
      id="defaults_client"
      inputId="defaults_client"
      class="order-entry__panel-client-details__data-client"
      mode="client"
      [disabled]="data.client.disabled"
      [allowEmpty]="true"
      [constraint]="data.client.accountConstraint"
      [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
      [(ngModel)]="data.client.value"
      (blur)="onClientChange($event)"
      (onTabChange)="onClientTabChange($event)"
      (onClientSelect)="onClientSelect($event)"
    >
    </ic-autocomplete-defaults>
    <!-- (ngModelChange)="onClientChange($event)" -->
  </div>
  <!-- ACCOUNT -->
  <div fxFlex="1 1 100%" class="order-entry-settings__ndf__row">
    <ic-autocomplete-defaults
      #inputAccount
      id="defaults_account"
      inputId="defaults_account"
      class="order-entry__panel-client-details__data-account"
      mode="account"
      [disabled]="data.account.disabled"
      [allowEmpty]="true"
      [constraint]="data.client.value"
      [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
      [(ngModel)]="data.account.value"
      (blur)="onAccountChange($event)"
      (onTabChange)="onAccountTabChange($event)"
    >
    </ic-autocomplete-defaults>
    <!--  (ngModelChange)="onAccountChange($event)" -->
  </div>
  <!-- CCY PAIR / ORDER TYPE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <ic-ccy-pair-defaults
      fxFlex="1 1 50%"
      #inputCcyPair
      id="oe-defaults_ndf_ccy-pair"
      inputId="currencyPair"
      class="bfx-component-wrapper"
      [label]="data.currencyPair.label"
      [dataset]="data.currencyPair.dataset"
      [marketRateDisable]="true"
      [(ngModel)]="data.currencyPair.product"
      [allowEmpty]="true"
      (ngModelChange)="onCurrencyPairChange($event)"
    >
    </ic-ccy-pair-defaults>
    <ic-autocomplete-defaults
      fxFlex="1 1 50%"
      #inputOrderType
      id="defaults_order-type"
      inputId="defaults_order-type"
      mode="type"
      [allowEmpty]="true"
      [label]="data.orderType.label"
      [disabled]="data.orderType.disabled"
      [dataset]="data.orderType.dataset"
      [(ngModel)]="data.orderType.value"
      (ngModelChange)="onOrderTypeChange($event)"
      class="bfx-component-wrapper"
    >
    </ic-autocomplete-defaults>
  </div>

  <!-- CCY PAIR / TYPE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
    [style.display]="control.showIntentAndAmount ? 'inherit' : 'none'"
  >
    <div
      fxFlex="1 1 50%"
      fxLayout="row"
      fxLayoutGap="4px"
      [style.padding-top]="0"
      class="bfx-component-wrapper"
    >
      <bfx-client-intent-toggle
        fxFlex="1 1 50%"
        #toggleClientIntent
        id="defaults_client-intent"
        inputId="defaults_client-intent"
        class="order-entry__panel-financials__client-intent"
        [label]="data.clientIntent.label"
        [(ngModel)]="data.clientIntent.value"
        (ngModelChange)="onClientIntentToggleChange($event)"
      >
      </bfx-client-intent-toggle>
      <ic-fixed-ccy
        fxFlex="1 1 50%"
        #toggleFixedCcy
        id="defaults_fixed-ccy"
        inputId="defaults_fixed-ccy"
        class="order-entry__panel-financials__fixed-ccy"
        [ccyPair]="data.fixedCcy.ccyPair"
        [(ngModel)]="data.fixedCcy.value"
        (ngModelChange)="onFixedCcyToggleChange($event)"
      >
      </ic-fixed-ccy>
    </div>
    <bfx-amount-spinner
      fxFlex="1 1 50%"
      #inputOrderAmount
      id="defaults_order-amount"
      inputId="defaults_order-amount"
      class="order-entry__panel-financials__order-amount bfx-component-wrapper"
      [label]="data.orderAmount.label"
      [mandatory]="false"
      [keyupAssignZero]="false"
      [minMaxTouchValid]="false"
      [currency]="data.fixedCcy.fixedCcy"
      [(ngModel)]="data.orderAmount.value"
      (ngModelChange)="onOrderAmountChange($event)"
      (blur)="onOrderAmountBlur($event)"
      [size]="'sm'"
    >
    </bfx-amount-spinner>
  </div>

  <!-- VALUE DATE / FIXING CODE -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <!-- VALUE DATE -->
    @if( !ndf1MOnly){
    <bfx-autoComplete
      fxFlex="1 1 50%"
      #inputValueDate
      id="defaults_value-date"
      inputId="defaults_value-date"
      class="interface-control__custom-input-autocomplete__container bfx-component-wrapper"
      [(ngModel)]="data.valueDate.value"
      [label]="data.valueDate.label"
      [suggestions]="data.valueDate.suggestions"
      [settingsCorrection]="true"
      [disabled]="data.valueDate.disabled"
      [autoHighlight]="true"
      [skipSorting]="true"
      delay="4"
      field="label"
      dataKey="value"
      [dropdown]="true"
      [allowEmptySelection]="true"
      [emptyIsInactive]="true"
      (ngModelChange)="valueDateOnBlur($event)"
      (completeMethod)="valueDateSuggestion($event)"
      [size]="'sm'"
      appendTo="body"
    >
    </bfx-autoComplete>
    }
    <!-- FIXING SOURCE -->
    <bfx-autoComplete
      fxFlex="1 1 50%"
      #inputFixingCode
      id="defaults_fixing-code"
      inputId="defaults_fixing-code"
      class="interface-control__custom-input-autocomplete__container bfx-component-wrapper"
      [(ngModel)]="data.fixingSource.value"
      [label]="data.fixingSource.label"
      [suggestions]="data.fixingSource.suggestions"
      [settingsCorrection]="true"
      [disabled]="data.fixingSource.disabled"
      [autoHighlight]="true"
      [skipSorting]="true"
      delay="4"
      field="label"
      dataKey="value"
      [dropdown]="true"
      [allowEmptySelection]="true"
      [emptyIsInactive]="true"
      (completeMethod)="searchFixingSources($event)"
      (ngModelChange)="onFixingCodeBlur()"
      [size]="'sm'"
      appendTo="body"
    >
    </bfx-autoComplete>
    <!-- Add column spacer when there's no value date so that width of fixing source stays consistent-->
    @if(ndf1MOnly){
    <div fxFlex="1 1 50%"></div>
    }
    <!-- order-entry__panel-financials__ndf_fixing_code -->
  </div>
  <!-- GOOD FROM/UNTIL  -->
  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <!-- GOOD FROM -->
    <div fxFlex="1 1 calc(50%- 20px)" class="input-good-date">
      <bfx-autoComplete
        #inputGoodFrom
        id="defaults_good-from"
        inputId="defaults_good-from"
        class="interface-control__custom-input-autocomplete__container bfx-component-wrapper"
        [(ngModel)]="data.goodFrom.value"
        [label]="data.goodFrom.label"
        [suggestions]="data.goodFrom.suggestions"
        [settingsCorrection]="true"
        [dropdown]="true"
        [skipSorting]="true"
        [autoHighlight]="true"
        [allowEmptySelection]="true"
        [emptyIsInactive]="true"
        delay="4"
        field="label"
        dataKey="value"
        (ngModelChange)="onGoodFromChange($event)"
        (completeMethod)="goodFromSuggestion($event)"
        [size]="'sm'"
        appendTo="body"
      >
      </bfx-autoComplete>
    </div>
    <!-- GOOD UNTIL -->
    <div fxFlex="1 1 calc(50%- 20px)" class="input-good-date">
      <bfx-autoComplete
        #inputGoodFrom
        id="defaults_good-until"
        inputId="defaults_good-until"
        class="interface-control__custom-input-autocomplete__container bfx-component-wrapper"
        [(ngModel)]="data.goodUntil.value"
        [label]="data.goodUntil.label"
        [suggestions]="data.goodUntil.suggestions"
        [settingsCorrection]="true"
        [dropdown]="true"
        [skipSorting]="true"
        [autoHighlight]="true"
        [allowEmptySelection]="true"
        [emptyIsInactive]="true"
        delay="4"
        field="label"
        dataKey="value"
        (ngModelChange)="onGoodUntilChange($event)"
        (completeMethod)="goodUntilSuggestion($event)"
        [size]="'sm'"
        appendTo="body"
      >
      </bfx-autoComplete>
    </div>
  </div>

  <div
    fxFlex="1 1 100%"
    class="order-entry-settings__ndf__row"
    [style.visibility]="data.privateOrder.show  ? 'visible': 'hidden'"
    fxLayout="row"
    fxLayoutGap="20px"
    fxLayoutAlign="start"
  >
    <ic-private-order-defaults
      fxFlex="1 1 50%"
      #inputPrivateOrder
      id="defaults_private-order"
      inputId="defaults_private-order"
      [loading]="control.isLoading"
      [label]="data.privateOrder.label"
      [(ngModel)]="data.privateOrder.value"
      (ngModelChange)="onPrivateOrderChange()"
    >
    </ic-private-order-defaults>
    <div fxFlex="1 1 50%"></div>
  </div>
</div>
